// Bewaart de bij login gekozen tenantcode. localStorage — consistent met
// MSAL's eigen cache (zie msalConfig.ts): de keuze moet in elke tab bekend
// zijn, want authProvider stopt zonder tenantcode met herstellen en komt dan
// niet eens aan restoreSession() toe. Wordt gewist bij logout (zie
// authProvider).
import { isTenantCode, TENANTS, type TenantCode } from './tenants';

const STORAGE_KEY = 'safezone.tenant';

export function getSelectedTenant(): TenantCode | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  return isTenantCode(raw) ? raw : null;
}

/**
 * Het weergavelabel van de tenant waarmee de gebruiker is ingelogd
 * (uit de registry). `null` wanneer er geen tenant gekozen is.
 */
export function getSelectedTenantLabel(): string | null {
  const code = getSelectedTenant();
  return code ? TENANTS[code].label : null;
}

export function setSelectedTenant(code: TenantCode): void {
  localStorage.setItem(STORAGE_KEY, code);
}

export function clearSelectedTenant(): void {
  localStorage.removeItem(STORAGE_KEY);
}

/**
 * Roept `onCleared` aan wanneer een *ander* tabblad de tenantkeuze wist —
 * uitloggen of een verlopen sessie. Het storage-event vuurt alleen in de
 * overige tabs, nooit in de tab die de wijziging zelf deed, dus een lus is
 * uitgesloten. Geeft een opzegfunctie terug.
 */
export function onSelectedTenantCleared(onCleared: () => void): () => void {
  const handler = (event: StorageEvent) => {
    if (event.storageArea !== localStorage) return;
    // key is null bij localStorage.clear(): dan is de keuze ook weg.
    if (event.key !== null && event.key !== STORAGE_KEY) return;
    // De actuele stand lezen in plaats van event.newValue vertrouwen: zo werkt
    // het ook bij clear() en bij een tussentijdse nieuwe login.
    if (getSelectedTenant() === null) onCleared();
  };
  window.addEventListener('storage', handler);
  return () => window.removeEventListener('storage', handler);
}
